export default __webpack_public_path__ + "static/media/brewery.fca53247.svg";